export interface FontResizerSettings {
    skipResize?: boolean;
    threshold?: number;
    minimumFontSize?: number;
}
export abstract class FontResizerBaseService {
    abstract getSettings(valueLen: number): FontResizerSettings;
}
